<template>
  <SearchableDropdown
    v-model="computedValue"
    class="form__searchable-dropdown"
    :config="publisherValueConfig"
    v-bind="{...$props, ...$attrs}"
  >
    <template #input="{prefix, numbersOnly, search}">
      <input
        v-prefix="prefix"
        v-numbers-only="numbersOnly"
        class="form-control vs__search--custom m-b-0"
        :class="{ closed: !search.attributes['aria-expanded'] }"
        v-bind="search.attributes"
        v-on="search.events"
      >
    </template>
  </SearchableDropdown>
</template>

<script>
import SearchableDropdown from '../SearchableDropdown/SearchableDropdown.vue';
import { mapActions, mapState } from 'vuex';
export default {
  components: { SearchableDropdown },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Object],
      default: () => undefined
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      publishers: 'affiliates'
    }),
    /** @type {() => {
     * options: unknown[];
     * placeholder: VueI18n.TranslateResult;
     * getOptionKey: (option: any) => any;
     * getOptionLabel: (option: any) => any;
     * clearable: boolean;
     *  }}
     */
    publisherValueConfig() {
      return {
        options: this.publishers,
        placeholder: this.placeholder,
        getOptionKey: r => r.id,
        getOptionLabel: r => r.name,
        clearable: false
      };
    },


    /**
     * Used for binding the v-model
     */
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('change', value);
      }
    }
  },

  // Load the list of publishers on first mount
  async beforeMount() {
    if(!this.publishers?.length) {
      this.getPublishers();
    }
  },
  methods: {
    ...mapActions({
      getPublishers: 'getAffiliates'
    }),
  }
};
</script>


<style lang="scss" scoped>
.form__searchable-dropdown {
  ::v-deep .failed .vs__search--custom {
    border-bottom: 1px solid transparent !important;
  }
}
</style>